import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import {
  IStandardGroup,
  IStandardGroupSearchRequest,
  IStandardGroupStandard,
  IStandardGroupStandardSearchRequest,
} from "../model/interface/standardGroup";

export const createStandardGroup = (
  standardGroup: IStandardGroup,
  standardGroupStandard: IStandardGroupStandard
) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_STANDARDGROUP}`,
    {
      StandardGroup: standardGroup,
      StandardGroupStandard: standardGroupStandard,
    },
    {}
  );
};

export const getStandardGroups = (
  standard: IStandardGroupSearchRequest,
  pageNumber: number,
  pageSize: number,
  sortBy?: string,
  orderByColumn?: string
) => {
  return AxiosHelper.axiosInstance().get(`${APIConstant.CMS_STANDARDGROUP}`, {
    params: {
      standardGroupId: standard.standardGroupId,
      name: standard.name,
      standardName: standard.standardName,
      stateId: standard.stateId,
      gradeId: standard.gradeId,
      subjectId: standard.subjectId,
      domainId: standard.domainId,
      isActive: standard.isActive,
      pageNumber: pageNumber,
      pageSize: pageSize,
      SortDir: sortBy,
      OrderByColumn: orderByColumn,
    },
  });
};

export const getStandardGroupStandards = (
  standard: IStandardGroupStandardSearchRequest,
  pageNumber: number,
  pageSize: number
) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_STANDARDGROUPStandard}`,
    {
      params: {
        standardGroupId: standard.standardGroupId,
        standardId: standard.standardId,
        isActive: standard.isActive,
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    }
  );
};

export const addNewStandard = (
  standardGroupStandard: IStandardGroupStandard
) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_STANDARDGROUPStandard}`,
    {
      StandardGroupStandard: standardGroupStandard,
    },
    {}
  );
};

export const deleteStandardGroup = (groupId: number, userId: number) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_STANDARDGROUP, {
    params: {
      standardGroupId: groupId,
      userId: userId,
    },
  });
};

export const deleteStandardGroupStandard = (
  groupId: number,
  standardId: number,
  userId: number
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_STANDARDGROUPStandard,
    {
      params: {
        standardGroupId: groupId,
        standardId: standardId,
        userId: userId,
      },
    }
  );
};

export const updateStandardGroup = (standardGroup: IStandardGroup) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_STANDARDGROUP}`,
    {
      StandardGroup: standardGroup,
    },
    {}
  );
};

export const getStandardGroup = (id: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_STANDARDGROUP}/${id}`,
    {}
  );
};
